import { useContext } from 'react';
import { EditorContext } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import { CommentEditorContext } from '../context';

/**
 * Returns `true` if the editor contains valid text that we can submit, regardless of if the user is
 * using the full featured editor or the fallback editor.
 */
export function useIsCommentEditorSubmittable() {
  const { isBusy, submitValidator } = useContext(CommentEditorContext);
  const { ref: editor, isEmpty } = useContext(EditorContext);

  if (submitValidator && editor) {
    return submitValidator(editor);
  }

  return !isEmpty && !isBusy;
}
